import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useRef, useState } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import cx from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import RadioGroup from 'ui/components/radio-group';
import ModalDialog from '../ui/modal-dialog';
import DropDown from '../ui/react-ui/dropdown';
import CheckboxGroup from '../ui/react-ui/checkbox-group';
import Form from '../ui/form';
import Input from '../ui/input';
import Validator from '../../utils/validator'; // api

import { createNvrAPI, editNvrAPI } from '../../api/settingAPI';
import { createCameraAPI, editCameraAPI, getCameraHLSStreamUrls } from '../../api/deviceAPI'; // redux

import { clearDialogInfo } from '../../redux/setting-device';
var t = i18n.getFixedT(null, 'setting-device');
var gt = i18n.getFixedT(null, 'app');
var et = i18n.getFixedT(null, 'errors');
var initNvrData = {
  id: null,
  name: '',
  ip: '',
  port: '',
  ivarId: '',
  status: true
};
var initCameraData = {
  id: null,
  name: '',
  ip: '',
  longitude: '',
  latitude: '',
  location: '',
  channel: '',
  streamUrl: '',
  streamUrlType: 'HLS',
  // status: 1,
  // current harbor is only TWKHH. if need to select other harbor, can use harborOptioins to be selected in setting-device redux
  harbor: {
    id: 'TWKHH'
  },
  nvr: {},
  terminal: {},
  deliverType: '',
  isAnalytic: true,
  isShowOnMap: true,
  dataSource: 'EVMS',
  username: '',
  password: '',
  sourceStreamUrl: ''
};

var isValidUrl = function isValidUrl(url) {
  try {
    var result = new URL(url);
    return !!result;
  } catch (err) {
    return false;
  }
};

var DeviceEdit = /*#__PURE__*/React.memo(function (props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      terminalsList = _useSelector.app.terminalsList,
      contextRoot = _useSelector.envCfg.contextRoot,
      _useSelector$device = _useSelector.device,
      _useSelector$device$d = _useSelector$device.dialogInfo,
      mode = _useSelector$device$d.mode,
      data = _useSelector$device$d.data,
      nvrOptions = _useSelector$device.nvrOptions;

  var dispatch = useDispatch();
  var id = props.id,
      onClose = props.onClose;

  var _useState = useState(initCameraData),
      _useState2 = _slicedToArray(_useState, 2),
      formData = _useState2[0],
      setFormData = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      hlsStreamUrl = _useState4[0],
      setHlsStreamUrl = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      error = _useState6[0],
      setError = _useState6[1];

  var formRef = useRef(null);

  var _confirmAPI = useRef();

  var _requiredField = useRef();

  var dialogModeAry = mode.split('.');
  var tab = dialogModeAry[0];
  var dialogTitle = t("lbl-".concat(dialogModeAry[1])) + t("lbl-".concat(tab));

  if (dialogModeAry[1] === 'detial') {
    dialogTitle = t("lbl-".concat(tab)) + t("lbl-".concat(dialogModeAry[1]));
  }

  var handleClose = function handleClose() {
    dispatch(clearDialogInfo());
    setFormData({});
    setError(null);
    _confirmAPI.current = null;
  };

  var handleChange = function handleChange(list) {
    setFormData(list);
  };

  var handleRadioChange = function handleRadioChange(val) {
    var newData = _.cloneDeep(formData);

    _.set(newData, 'deliverType', val);

    handleChange(newData);
  };

  var handleChangeInputValue = function handleChangeInputValue(val, type) {
    var newData = _.cloneDeep(formData);

    _.set(newData, type, val);

    handleChange(newData);
  };

  var handleStreamUrlTypeChange = function handleStreamUrlTypeChange(val, type) {
    // only one type can be selected
    if (val.length === 0) return;

    if (val.length > 1) {
      val = [val[val.length - 1]];
    }

    var currentVal = val[0];

    var newData = _.cloneDeep(formData);

    _.set(newData, type, currentVal); // If the stream type is changed to MJPEG, the streamUrl input should be empty to let the user input a new URL.
    // The default stream type is HLS, so the streamUrl will be set to the HLS URL.


    if (currentVal === 'MJPEG') {
      if (data.streamUrlType === 'HLS') {
        _.set(newData, 'streamUrl', '');
      }

      if (data.streamUrlType === 'MJPEG') {
        _.set(newData, 'streamUrl', data.streamUrl);
      }
    }

    if (currentVal === 'HLS') {
      _.set(newData, 'streamUrl', hlsStreamUrl);
    }

    error && setError(null);
    setFormData(newData);
  };

  var handleDropDownChange = function handleDropDownChange(val, type) {
    var newData = _.cloneDeep(formData);

    _.set(newData, "".concat(type, ".id"), val);

    handleChange(newData);
  };

  var handleConfirm = function handleConfirm() {
    var fillOutRequired = Validator(_requiredField.current, formData);

    var saveData = _.cloneDeep(formData);

    if (fillOutRequired.length > 0) {
      return setError(et('txt-fill-out-required'));
    }

    if (mode.indexOf('analyticCamera') >= 0) {
      // if(_.isEmpty(formData.terminal.id))
      //     return setError(t('txt-selected-terminal'))
      if (_.isEmpty(formData.nvr.id)) {
        return setError(t('txt-selected-nvr'));
      }
    }

    if (mode.indexOf('cctv') >= 0) {
      if (_.isEmpty(formData.nvr.id)) {
        return setError(t('txt-selected-nvr'));
      }

      _.set(saveData, 'deliverType', '');
    }

    if (mode.indexOf('edit') >= 0) {
      if (mode.indexOf('analyticCamera') >= 0 || mode.indexOf('cctv') >= 0) {
        if (saveData.streamUrlType === 'HLS') {
          _.set(saveData, 'streamUrl', '');
        }

        if (saveData.streamUrlType === 'MJPEG') {
          if (_.isEmpty(saveData.streamUrl)) {
            return setError(t('txt-fill-out-required'));
          }

          if (!isValidUrl(saveData.streamUrl)) {
            return setError(t('txt-no-match'));
          }
        }
      }
    }

    _confirmAPI.current(contextRoot, false, saveData).then(function (result) {
      setFormData({});
      setError(null);
      onClose();
    }).catch(function (error) {
      setError(error.message);
    });
  };

  useEffect(function () {
    if (_.isEmpty(mode)) {
      return null;
    }

    var modeAry = mode.split('.');
    var modeItem = modeAry[0];
    var modeType = modeAry[1];

    switch (modeItem) {
      case 'analyticCamera':
      case 'cctv':
        _confirmAPI.current = modeType === 'create' ? createCameraAPI : editCameraAPI;
        _requiredField.current = ['name', 'location', 'channel'];

        var initData = _.cloneDeep(initCameraData);

        if (modeItem === 'cctv') {
          _.set(initData, 'isAnalytic', false);
        }

        if (data.id) {
          getCameraHLSStreamUrls(contextRoot, false, data.id).then(function (result) {
            setHlsStreamUrl(result[0]);
          }).catch(function (error) {
            setError(error.message);
          });
        }

        setFormData(initData);
        break;

      case 'nvr':
        _confirmAPI.current = modeType === 'create' ? createNvrAPI : editNvrAPI;
        _requiredField.current = ['name', 'ip', 'port', 'ivarId'];
        setFormData(initNvrData);
        break;

      default:
        break;
    }

    if (mode.indexOf('edit') < 0 && mode.indexOf('detial') < 0) return;
    setFormData(_.cloneDeep(data));
  }, [mode, data.id]);

  if (_.isEmpty(mode) || mode.indexOf('edit') > 0 && _.isEmpty(formData.id) || _.isEmpty(formData)) {
    return null;
  }

  var actions = {};

  if (mode.indexOf('edit') > 0 || mode.indexOf('create') > 0) {
    _.set(actions, 'cancel', {
      text: gt('global.lbl-answer-cancel'),
      handler: handleClose
    });

    _.set(actions, 'confirm', {
      text: gt('global.lbl-answer-ok'),
      className: 'button-success',
      // disabled: !formValid,
      handler: handleConfirm
    });
  } else {
    _.set(actions, 'cancel', {
      text: gt('global.lbl-close'),
      handler: handleClose
    });
  }

  var fields = {};

  switch (tab) {
    case 'analyticCamera':
    case 'cctv':
      _.set(fields, 'name', {
        label: t('lbl-camera-name'),
        editor: Input,
        props: {
          required: true,
          validate: {
            t: function t(code) {
              return et("txt-".concat(code));
            }
          }
        }
      });

      _.set(fields, 'location', {
        label: t('lbl-location'),
        editor: Input,
        props: {
          required: true,
          validate: {
            t: function t(code) {
              return et("txt-".concat(code));
            }
          }
        }
      });

      _.set(fields, 'username', {
        label: t('dlg-camera-account'),
        editor: Input,
        props: {
          // required: true,
          validate: {
            t: function t(code) {
              return et("txt-".concat(code));
            }
          }
        }
      });

      _.set(fields, 'password', {
        label: t('dlg-camera-password'),
        editor: Input,
        props: {
          // required: true,
          validate: {
            t: function t(code) {
              return et("txt-".concat(code));
            }
          }
        }
      }); // if(tab === 'analyticCamera') {
      //     _.set(fields, 'terminal', {
      //         label:t('lbl-terminals'),
      //         formatter: (val, row) => {
      //             return <DropDown list={terminalsList} width={'220px'} defaultText={gt('global.lbl-select')} value={val.id ? val.id : ''} onChange={value => handleDropDownChange(value, 'terminal')} />
      //         }
      //     })
      //     let radioList = [
      //         { key: 'PickUp', value: 'PickUp', text: t('lbl-PICKUP')},
      //         { key: 'Return', value: 'Return', text: t('lbl-RETURN')},
      //     ]
      //     _.set(fields, 'deliverType', {
      //         label:t('lbl-container-deliver-types'),
      //         formatter: (val, row) => {
      //             return <RadioGroup list={radioList} value={val ? val : 'PickUp'} onChange={value => handleRadioChange(value)} />
      //         }
      //     })
      // }


      _.set(fields, 'longitude', {
        label: t('dlg-longitude'),
        formatter: function formatter(val, row) {
          return /*#__PURE__*/React.createElement(Input, {
            value: val || '',
            validate: {
              required: true,
              pattern: /^[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/,
              t: function t(code) {
                return et("txt-".concat(code));
              }
            },
            onChange: function onChange(val) {
              return handleChangeInputValue(val, 'longitude');
            }
          });
        }
      });

      _.set(fields, 'latitude', {
        label: t('dlg-latitude'),
        formatter: function formatter(val, row) {
          return /*#__PURE__*/React.createElement(Input, {
            value: val || '',
            validate: {
              required: true,
              pattern: /^\s*[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)$/,
              t: function t(code) {
                return et("txt-".concat(code));
              }
            },
            onChange: function onChange(val) {
              return handleChangeInputValue(val, 'latitude');
            }
          });
        }
      });

      _.set(fields, 'nvr', {
        label: t('lbl-nvr'),
        formatter: function formatter(val, row) {
          if (mode.indexOf('edit') >= 0) {
            return row.nvr.name;
          }

          return /*#__PURE__*/React.createElement(DropDown, {
            list: nvrOptions,
            width: '220px',
            defaultText: gt('global.lbl-select'),
            value: val.id ? val.id : '',
            onChange: function onChange(value) {
              return handleDropDownChange(value, 'nvr');
            }
          });
        }
      });

      _.set(fields, 'channel', {
        label: t('lbl-nvr-channel'),
        formatter: function formatter(val, row) {
          if (mode.indexOf('edit') > 0) {
            return val;
          }

          return /*#__PURE__*/React.createElement(Input, {
            value: val || '',
            validate: {
              required: true,
              pattern: /^[0-9]*$/,
              t: function t(code) {
                return et('txt-not-int');
              }
            },
            onChange: function onChange(val) {
              return handleChangeInputValue(val, 'channel');
            }
          });
        }
      });

      if (mode.indexOf('create') > 0 || formData.sourceStreamUrl) {
        _.set(fields, 'sourceStreamUrl', {
          label: t('dlg-rtsp-url'),
          formatter: function formatter(val, row) {
            if (mode.indexOf('edit') > 0) {
              return val;
            }

            return /*#__PURE__*/React.createElement(Input, {
              value: val || '',
              validate: {
                // required: true,
                t: function t(code) {
                  return et("txt-".concat(code));
                }
              },
              onChange: function onChange(val) {
                return handleChangeInputValue(val, 'sourceStreamUrl');
              }
            });
          }
        });
      }

      if (mode.indexOf('edit') > 0) {
        _.set(fields, 'streamUrl', {
          label: t('dlg-stream-Url'),
          formatter: function formatter(val, row) {
            return /*#__PURE__*/React.createElement("div", {
              className: "device-edit-streamUrl"
            }, /*#__PURE__*/React.createElement(CheckboxGroup, {
              id: "streamUrlTypes",
              list: [{
                value: 'HLS',
                text: 'HLS'
              }, {
                value: 'RTSP',
                text: 'RTSP'
              }, {
                value: 'HTTP',
                text: 'HTTP'
              }, {
                value: 'MJPEG',
                text: 'MJPEG'
              }],
              onChange: function onChange(val) {
                handleStreamUrlTypeChange(val, 'streamUrlType');
              },
              value: [formData.streamUrlType],
              disabled: ['RTSP', 'HTTP']
            }), formData.streamUrlType === 'HLS' && /*#__PURE__*/React.createElement("div", null, val), formData.streamUrlType === 'MJPEG' && /*#__PURE__*/React.createElement(Input, {
              value: val,
              onChange: function onChange(val) {
                return handleChangeInputValue(val, 'streamUrl');
              }
            }));
          }
        });
      }

      break;

    case 'road':
      _.set(fields, 'name', {
        label: t('lbl-camera-name'),
        formatter: function formatter(value) {
          return value;
        }
      });

      _.set(fields, 'location', {
        label: t('lbl-location'),
        formatter: function formatter(value) {
          return value;
        }
      });

      _.set(fields, 'latlng', {
        label: t('lbl-lat-lng'),
        formatter: function formatter(val, row) {
          return /*#__PURE__*/React.createElement("div", null, row.latitude + ', ' + row.longitude);
        }
      });

      _.set(fields, 'streamUrl', {
        label: t('lbl-connected-video-url'),
        formatter: function formatter(value) {
          return value;
        }
      });

      _.set(fields, 'dataSource', {
        label: t('dlg-source'),
        formatter: function formatter(value) {
          return value;
        }
      });

      _.set(fields, 'isShowOnMap', {
        label: t('dlg-is-show-on-map'),
        formatter: function formatter(value) {
          return value ? t('dlg-yes') : t('dlg-no');
        }
      });

      break;

    case 'nvr':
      _.set(fields, 'name', {
        label: t('lbl-nvr-name'),
        editor: Input,
        props: {
          required: true,
          validate: {
            t: function t(code) {
              return et("txt-".concat(code));
            }
          }
        }
      });

      _.set(fields, 'ip', {
        label: t('lbl-ip'),
        editor: Input,
        props: {
          validate: {
            pattern: /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$|^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)+([A-Za-z]|[A-Za-z][A-Za-z0-9\-]*[A-Za-z0-9])$/,
            required: true,
            t: function t(code) {
              return et("txt-".concat(code));
            }
          }
        }
      });

      _.set(fields, 'port', {
        label: t('lbl-port'),
        editor: Input,
        props: {
          validate: {
            pattern: /^[0-9]{1,5}$/,
            required: true,
            t: function t(code) {
              return et("txt-".concat(code));
            }
          }
        }
      });

      _.set(fields, 'ivarId', {
        label: t('lbl-ivar-id'),
        editor: Input,
        props: {
          required: true,
          validate: {
            t: function t(code) {
              return et("txt-".concat(code));
            }
          }
        }
      });

      break;

    case 'tipcCctv':
      _.set(fields, 'branch', {
        label: t('lbl-branch'),
        formatter: function formatter(value) {
          return value;
        }
      });

      _.set(fields, 'name', {
        label: t('lbl-camera-name'),
        formatter: function formatter(value) {
          return value;
        }
      });

      _.set(fields, 'location', {
        label: t('lbl-location'),
        formatter: function formatter(val, row) {
          return row.harbor + '-' + row.area;
        }
      });

      _.set(fields, 'latlng', {
        label: t('lbl-lat-lng'),
        formatter: function formatter(val, row) {
          return /*#__PURE__*/React.createElement("div", null, row.latitude + ', ' + row.longitude);
        }
      });

      _.set(fields, 'nvrName', {
        label: t('lbl-nvr-name'),
        formatter: function formatter(value) {
          return value;
        }
      });

      _.set(fields, 'nvrIp', {
        label: t('lbl-nvr-ip'),
        formatter: function formatter(value) {
          return value;
        }
      });

      _.set(fields, 'nvrChannel', {
        label: t('lbl-nvr-channel'),
        formatter: function formatter(value) {
          return value;
        }
      });

      _.set(fields, 'rtspUrl', {
        label: t('lbl-rtsp-url'),
        formatter: function formatter(value) {
          return value;
        }
      });

      break;

    default:
      break;
  }

  return /*#__PURE__*/React.createElement(ModalDialog, {
    id: id,
    title: dialogTitle,
    global: true,
    info: error,
    infoClassName: cx({
      'c-error': error
    }),
    actions: actions,
    closeAction: "cancel"
  }, /*#__PURE__*/React.createElement(Form, {
    id: "".concat(id, "-form"),
    ref: formRef,
    className: "pure-form-aligned",
    fieldClassName: "pure-control-group",
    fields: fields,
    onChange: handleChange,
    value: formData
  }));
});
DeviceEdit.defaultProps = {
  id: 'g-device-create-edit'
};
DeviceEdit.propTypes = {
  id: PropTypes.string
};
export default DeviceEdit;